export const ROW_SIZE = 43;
export const DROPDOWN_LIST_HEIGHT = 245;
export enum ClickOutsideArea {
  /** The area that was clicked outside of was the input */
  INPUT,
  /** The area that was clicked outside of was the dropdown menu */
  MENU,
}
